import { cssInterop } from 'nativewind';
import { useMemo } from 'react';
import { cn } from '../../utils/cn';
import { isWeb } from '../../utils/platform';
import { customIconMap } from './customIconMap';
import { CustomIconName, IconSizeValue, resolveIconSize } from './icon';

interface Props extends Pick<React.SVGProps<SVGSVGElement>, 'color'> {
  name: CustomIconName;
  size?: IconSizeValue;
  className?: string;
}

export const CustomIcon = ({ name, size = 'small', color, className }: Props) => {
  const CustomIconComponent = useMemo(() => {
    const Icon = customIconMap[name];
    if (!Icon) {
      return null;
    }

    return cssInterop(Icon, {
      className: {
        target: 'style',
        nativeStyleToProp: {
          color: true,
          width: true,
          height: true,
          stroke: true,
          fill: true,
          opacity: true
        }
      }
    });
  }, [name]);
  const iconSize = resolveIconSize(size);

  if (!CustomIconComponent) {
    return null;
  }

  return (
    // eslint-disable-next-line react-hooks/static-components -- cssInterop wrapper is memoized on name, so its identity only changes when the icon does
    <CustomIconComponent
      width={iconSize}
      height={iconSize}
      className={cn(className, 'shrink-0')}
      // currentColor not supported for mobile...
      color={color ?? (isWeb ? 'currentColor' : 'black')}
    />
  );
};
